




















import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import { format, parseISO } from "date-fns";

import ModalTabs from "../../DashboardLayoutComponents/ModalTabs.vue";
import FormField from "../../DashboardLayoutComponents/FormField.vue";
import EspressoAux from '../../../components/Espresso/EspressoAux.vue';

import ShiftCard from "@/layouts/DashboardLayoutComponents/ShiftCard.vue";

import shiftModel from "@/models/shift.model";

@Component({
	components: { ModalTabs, FormField, ShiftCard, VueperSlides, VueperSlide },
})
export default class AnnounceModal extends Vue {
	tabs = [
		{ iconClass: 'fa fa-bullhorn', iconSize: '0.95rem !important', name: 'Anunciar', actionName: 'Anunciar plantões', action: this.announceShifts },
	];

	@Prop() calendarDays: any[];

	auditNotes = "";

	constructor() {
		super();
	}

	updateNotes(notes: string) {
		this.auditNotes = notes;
	}

	private async announceShifts() {
		const selectedShifts: any[] = [].concat(...this.calendarDays.map(day => day.shifts));
		for (const shift of selectedShifts) {
			const shiftDate = format(parseISO(shift.startDateTime), "dd/MM/yyyy HH:mm");
			try {
				await shiftModel.announce(shift.id, this.auditNotes);
				this.$toasted.success(`O plantão do dia ${shiftDate} foi anunciado`, { duration: 5000 });
			} catch (error) {
				console.error(error);
				this.$toasted.error(`Não foi possível anunciar o plantão do dia ${shiftDate}. Tente novamente.`)
				throw error;
			}
		}
		this.$emit("close");
	}
}
